import createItemFetcher from "../helpers/item";
import { combineDucks } from "../helpers/combineDucks";
import { createActionDuck } from "../helpers/action";
import { createNotificationOnPostErrorEpic, createNotificationOnFetchErrorEpic, } from "./notifications";
const SAVE_URL = () => ({
    url: "/api/v1/dashboard",
    method: "POST",
});
const LOAD_URL = () => "/api/v1/dashboard";
const dashboardID = () => "DASHBOARD";
const saveDashboardService = () => createActionDuck("saveDashboard", SAVE_URL, dashboardID);
const loadDashboardService = () => createItemFetcher(LOAD_URL, "LOAD_DASHBOARD", dashboardID);
export const createDashboardService = () => {
    const combinedDuck = combineDucks({
        saveDashboard: saveDashboardService(),
        loadDashboard: loadDashboardService(),
    });
    const postErrorEpic = createNotificationOnPostErrorEpic(saveDashboardService().ActionKeys);
    const fetchErrorEpic = createNotificationOnFetchErrorEpic(loadDashboardService().ActionKeys);
    combinedDuck.middleware.push(postErrorEpic, fetchErrorEpic);
    return combinedDuck;
};
//# sourceMappingURL=index.js.map